"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Calendar = function Calendar() {
    return _react2.default.createElement(
        "g",
        { id: "calendar" },
        _react2.default.createElement("path", { d: "M174.883094,224.820144 L124.919065,224.820144 L124.919065,274.784173 L174.883094,274.784173 L174.883094,224.820144 Z M274.802158,224.820144 L224.838129,224.820144 L224.838129,274.784173 L274.802158,274.784173 L274.802158,224.820144 Z M374.721223,224.820144 L324.757194,224.820144 L324.757194,274.784173 L374.721223,274.784173 L374.721223,224.820144 Z M424.676259,49.955036 L399.703237,49.955036 L399.703237,0 L349.739209,0 L349.739209,49.955036 L149.901079,49.955036 L149.901079,0 L99.9370504,0 L99.9370504,49.955036 L74.9640288,49.955036 C61.7372619,49.9596734 49.0572537,55.2332855 39.7281729,64.6096193 C30.3990921,73.9859531 25.1896104,86.6924432 25.2517986,99.9190647 L25,449.640288 C24.9952268,462.893035 30.2577462,475.604355 39.6288541,484.975462 C48.999962,494.34657 61.7112817,499.60909 74.9640288,499.604317 L424.676259,499.604317 C452.237828,499.525286 474.561258,477.201857 474.640288,449.640288 L474.640288,99.9190647 C474.561258,72.3574953 452.237828,50.034066 424.676259,49.955036 L424.676259,49.955036 Z M424.676259,449.631295 L74.9640288,449.631295 L74.9640288,174.856115 L424.676259,174.856115 L424.676259,449.631295 Z", id: "Shape" })
    );
};

exports.default = Calendar;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Calendar.js
// module id = 2929
// module chunks = 4